import Vue from "vue";
import moment from "moment";
import tripEventDetail from "./detail/trip-events-detail.vue";
import { bus } from "../../../../main";
import helpers from "../../../../shared/fleetbox-helpers";
import filters from "./filters/trip-events-filter.vue";

export default {
	components: {
		tripEventDetail,
		filters
	},
	data: function() {
		return {
			//#region filters
			filters: [
				{
					id: "timerange",
					items: [],
					value: {
						startRange: moment().startOf("day"),
						endRange: moment().endOf("day")
					}
				},
				{
					id: "vehicles",
					items: [],
					value: []
				}
			],
			//#endregion filters

			isDetailLoading: false,

			reportName: ""
		};
	},

	created() {
		var self = this;

		//bus.$emit("show-spinner-loading");

		helpers.getReportName().then(res => {
			if (res) {
				var report = res.find(item => {
					return item.id == 260;
				});

				if (report) {
					self.reportName = report.name;
				}
				else {
					self.reportName = "Report analitico giornaliero";
				}
			}
		});
	},
	mounted() {},

	watch: {
		isDetailLoading: {
			handler: function() {
				this.loadingProgressUpdate();
			}
		}
	},

	methods: {
		//#region loading progress
		loadingProgressUpdate() {
			if (this.isDetailLoading) {
				bus.$emit("show-spinner-loading");
			}
			else {
				bus.$emit("hide-spinner-loading");
			}
		},
		onDetailLoading(isLoading) {
			this.isDetailLoading = isLoading;
		},
		onChartLoading(isLoading) {
			this.isChartLoading = isLoading;
		},
		//#endregion
		//#region filters events
		onFilterApplyClick() {
			if (this.$refs.tripEventsDetailReport) {
				this.$refs.tripEventsDetailReport.applyReportFilter();
			}
		},
		onFilterResetClick() {
			this.setDefaultFilters();
			this.onFilterApplyClick();
		},
		onFilterTimerangeChange(newValue) {
			var timeRangeFilter = this.filters.find(item => {
				return item.id == "timerange";
			});
			if (timeRangeFilter) {
				timeRangeFilter.value.startRange = moment(newValue.startDate);
				timeRangeFilter.value.endRange = moment(newValue.endDate);
			}
		},
		onFilterPlateChange(newValue) {
			var vehiclesFilter = this.filters.find(item => {
				return item.id == "vehicles";
			});
			if (vehiclesFilter) {
				Vue.set(vehiclesFilter, "value", newValue);
			}
		},
		setDefaultFilters() {
			this.filters[0].value.startRange = moment().startOf("day");
			this.filters[0].value.endRange = moment().endOf("day");

			for (var i = 1; i < this.filters.length; i++) {
				var flt = this.filters[i];

				Vue.set(flt, "value", []);
			}
		}
		//#endregion filters events
	},
	computed: {}
};
